module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Explosivstoffe.ba69dc13.svg";